var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "88",
        "height": "88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "0%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorShowBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "stroke": "url(#a)",
        "stroke-width": "2",
        "cx": "44",
        "cy": "44",
        "r": "43"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill": "var(--homeIconCenterColor)",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M48.566 33.233v.088c-.133-.027-.133-.061 0-.088v-.09.09zm-6.28 13.333a2.148 2.148 0 002.058 2.222 2.148 2.148 0 002.058-2.236 2.148 2.148 0 00-2.057-2.208 2.133 2.133 0 00-2.045 2.222h-.014z"
      }
    }), _c('path', {
      attrs: {
        "d": "M48.433 48.788a.977.977 0 00-.8.43 3.941 3.941 0 01-6.592 0 .919.919 0 00-.8-.43h-8.208a1.067 1.067 0 00-1.021 1.097v6.667a1.081 1.081 0 001.021 1.125h24.623a1.081 1.081 0 001.022-1.11V49.9a1.067 1.067 0 00-1.022-1.098l-8.223-.013v-.001zM38.183 32.12v14.445H55.62V32.121a1.081 1.081 0 00-1.023-1.11H39.204a1.081 1.081 0 00-1.022 1.11h.002zM51.029 42.67h-8.164a1.11 1.11 0 010-2.207h8.192c.535.004.985.403 1.052.934a1.096 1.096 0 01-1.008 1.273h-.074.002zm0-5.007h-8.164a1.11 1.11 0 010-2.208h8.192c.535.004.985.403 1.052.934a1.096 1.096 0 01-1.008 1.274h-.074.002zm-14.906 8.89h-3.066V34.344a1.081 1.081 0 011.022-1.11h2.044v13.332-.014z"
      }
    })])])]));
  }
};